import { TableCell, TableFooter, TableRow } from '@mui/material';

export default function MonitoringNominalFooter({
  displayData, rows, columns, amountField = 'nominal', label = 'Total Nominal'
}) {
  const total = displayData.reduce((sum, row) => {
    const nominal = Number(rows[row.dataIndex]?.[amountField]);
    return sum + (Number.isFinite(nominal) ? nominal : 0);
  }, 0);

  return (
    <TableFooter>
      <TableRow>
        <TableCell
          colSpan={columns.filter((column) => column.display === true || column.display === 'true').length}
          sx={{ textAlign: 'right', fontWeight: 700, fontSize: 16, backgroundColor: '#f8f8f8' }}
        >
          {label}: Rp {total.toLocaleString('id-ID')}
        </TableCell>
      </TableRow>
    </TableFooter>
  );
}
